import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { HomeScreen } from './Screens';
import { GoogleTagManagerProvider } from "@tracktor/react-google-tag-manager";
import './styles/global.css';
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('user_id');
    localStorage.setItem('session', JSON.stringify({ sub: userId || 'not_provided' }));
  }, []);

  return (
    <GoogleTagManagerProvider id={process.env.REACT_APP_GTM_ID}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HomeScreen />
      </ThemeProvider>
    </GoogleTagManagerProvider>
    );
}

export default App;
